module.exports = __webpack_public_path__ + "static/media/undo-icon-active.ff5c347b.svg";